import React, { useEffect, useState } from 'react';
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import storage from "../../../utils/storage";
import { useFormik } from "formik";
import appActions from "../../../appActions";
import { InputText } from "primereact/inputtext";
import { authTypeOptions, statusOptions,  yesNoOptions } from "../../../utils/mics";
import { MultiSelect } from "primereact/multiselect";

const UserForm = ({ user, isEditMode, isViewMode, onClose, onSave }) => {
    
    const dispatch = useDispatch();
    const currentUser = JSON.parse(storage.get('loginUser'));
    const [siteIdMultiSelect, setSiteIdMultiSelect] = useState([]);

    const storeOtions = useSelector((state) => state.common.storeList);
    const rolesOtions = useSelector((state) => state.common.rolesList);

    useEffect(() => {
        if(user) {
            const splitSiteId = user['siteId'] ? user['siteId'].split(',').map(id => parseInt(id, 10)) || [] : [];
            setSiteIdMultiSelect( splitSiteId )
            
        }
    }, [ user ])

    const formik = useFormik({
        initialValues: {
            userId: user?.userId || "",
            firstName: user?.firstName || "",
            lastName: user?.lastName || "",
            authType: user?.authType || "",
            authTypeValue: user?.authTypeValue || "",
            emailId: user?.emailId || "",
            additionalFields: user?.additionalFields || {},
            createdOn: user?.createdOn || "",
            lastUpdatedBy: currentUser?.userId || "",
            userGroup: user?.userGroup || "",
            siteId: user?.siteId || "",
            sendNotificationBy: user?.sendNotificationBy || "N",
            userRole: user?.userRole || "",
            status: user?.status || "Active",
        },
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (!data.userId) errors.userId = 'User Id is required.';
            if (!data.firstName) errors.firstName = 'First Name is required.';
            if (!data.lastName) errors.lastName = 'Last Name is required.';
            if (!data.authType) errors.authType = 'Auth Type is required.';
            if (!data.authTypeValue) errors.authTypeValue = 'Auth Type Value is required.';
            if (!data.emailId) errors.emailId = 'Email Id is required.';
            if (!data.siteId) errors.siteId = 'Site Id is required.';
            if (!data.userRole) errors.userRole = 'User Role is required.';
            if (!data.status) errors.status = 'Status is required.';
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                id: isEditMode ? user?.id : null,
                siteId: values?.siteId || '',
                lastUpdatedBy: currentUser?.userId,
            }
            handleCreate(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const handleCreate = (data) => {
        if (isEditMode) {
            dispatch(appActions.USERS_UPDATE_REQUEST(data));
        } else {
            delete data?.id
            dispatch(appActions.USERS_CREATE_REQUEST(data));
        }
        onSave();
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    const handleSiteIdMultiSelect = (value) => {
        const selectedValue = value;
        setSiteIdMultiSelect(value);
        formik.setFieldValue('siteId', selectedValue?.join(',') || '');
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="grid formgrid mt-2">

                    <div className="field col-4">
                        <label htmlFor="firstName" className="flex align-items-center required"> First Name </label>
                        <InputText
                            className="w-full"
                            id="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            placeholder="First Name"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('firstName')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="lastName" className="flex align-items-center required"> Last Name </label>
                        <InputText
                            className="w-full"
                            id="lastName"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            placeholder="Last Name"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('lastName')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="userId" className="flex align-items-center required"> User Id </label>
                        <InputText
                            className="w-full"
                            id="userId"
                            value={formik.values.userId}
                            onChange={formik.handleChange}
                            placeholder="User ID"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('userId')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="emailId" className="flex align-items-center required"> Email Id </label>
                        <InputText
                            className="w-full"
                            id="emailId"
                            value={formik.values.emailId}
                            onChange={formik.handleChange}
                            placeholder="Email ID"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('emailId')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="authType" className="flex align-items-center required"> Auth Type </label>
                        <Dropdown
                            className="w-full"
                            id="authType"
                            value={formik.values.authType}
                            options={authTypeOptions}
                            optionLabel="name"
                            optionValue='code'
                            onChange={(e) => formik.setFieldValue('authType', e.value)}
                            placeholder="Auth Type"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('authType')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="userRole" className="flex align-items-center required"> User Role </label>
                        <Dropdown
                            className="w-full"
                            value={formik.values.userRole}
                            options={rolesOtions}
                            onChange={(e) => formik.setFieldValue('userRole', e.value)}
                            placeholder="User Role"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('userRole')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="authTypeValue" className="flex align-items-center required"> Auth Type Value </label>
                        <InputText
                            type="password"
                            className="w-full"
                            id="authTypeValue"
                            value={formik.values.authTypeValue}
                            onChange={formik.handleChange}
                            placeholder="Auth Type Value"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('authTypeValue')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="siteId" className="flex align-items-center required"> Site Id </label>
                        <MultiSelect
                            className="w-full"
                            value={siteIdMultiSelect}
                            options={storeOtions}
                            id="siteId"
                            filter
                            onChange={(e) => handleSiteIdMultiSelect(e.value)}
                            placeholder="Site Id"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('siteId')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="sendNotificationBy" className="flex align-items-center"> Send Notification</label>
                        <Dropdown
                            className="w-full"
                            id="sendNotificationBy"
                            value={formik.values.sendNotificationBy}
                            options={yesNoOptions}
                            optionLabel="name"
                            optionValue='code'
                            onChange={(e) => formik.setFieldValue('sendNotificationBy', e.value)}
                            placeholder="Send Notification"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('sendNotificationBy')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="status" className="flex align-items-center required"> Status </label>
                        <Dropdown
                            className="w-full"
                            id="status"
                            value={formik.values.status}
                            options={statusOptions}
                            optionLabel="name"
                            optionValue='code'
                            onChange={(e) => formik.setFieldValue('status', e.value)}
                            placeholder="Status"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('status')}
                    </div>

                    <div className="field col-12">
                        <div className="flex justify-content-end mt-4">
                            {isViewMode ? (
                                <Button
                                    type="button"
                                    label="Close"
                                    onClick={handleClose}
                                    severity="secondary"
                                />
                            ) : (
                                <Button
                                    type="submit"
                                    label="Create"
                                    severity="basic"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default UserForm;
